import VRadioGroup from './VRadioGroup.vue';
import VRadio from './VRadio.vue';

export { VRadioGroup, VRadio };
export default { VRadioGroup, VRadio };
